

export const projects = [
    
      {
        id:1,
        title: "KidneyApp",
        desc: "Companion App for renal chronic disease pacients. Frontend: Unity. Backend: NodeJS & MongoDB. Final Degree Project.",
        img: "../../assets/logo_noback.png",
        link: "https://github.com/NestorSaga/KidneyApp",
        tags: ['Team Project'],
        role: ' UI Design/Systems Design/Code',
        platform: ' Android & IOs',
        engine: ' Unity, NodeJS & MongoDB',
        isBig: false
      },
      {
        id:2,
        title: "AR IOs App",
        desc: "Pacient-focused app with eye tracking using ARKit. Developed for medical research in collaboration with BrainGaze and University of Barcelona",
        img: "../../assets/braingaze.png",
        link: null,
        tags: ['Solo Project/Company'],
        role: ' UI Design/AR integration/Code',
        platform: 'IOs',
        engine: ' Unity',
        isBig: false
      },
      {
        id:2,
        title: "Card System for Tabletop RPG",
        desc: "Card-based battle system for digital tabletop roleplaying campaings. Designed to be played on Tabletop Simulator",
        img: "../../assets/rolete.png",
        link: "https://drive.google.com/uc?id=1vsGkLwzktBp0gQNw1KIf8nz2H1WJYsUm",
        tags: ['Solo Project'],
        role: ' Design',
        platform: ' PC',
        engine: ' Tabletop Engine',
        isBig: false
      }
]


export const games = [
  {
    id: 1,
    title: "Farlands",
    desc: "Farlands is a cozy farming and exploration game where you buy and restore a neglected planet. You grow crops, gather resources, upgrade tools and your spaceship, and travel to other worlds. Along the way, you meet neighbors, join community events, and shape your new life among the stars.",
    img: "LxBEEpGDryQ",
    link: "https://store.steampowered.com/app/2252680/Farlands/",
    tags: ['JanduSoft', '1000+ reviews', '93% positive'],
    role: ' Code, Technical Design',
    platform: ' PC, (Upcoming: Switch, Xbox, PS4)',
    engine: ' Unity',
    isVideo: 'true',
    isBig: true
  },
  {
    id: 2,
    title: "OrbitRush",
    desc: "Singleplayer mobile speed focused platformer played only with one finger while running away from an exploding sun.",
    img: "prkS7DCh1mE",
    link: "",
    tags: ['Solo Project', 'Prototype'],
    role: ' Code/Design/UI',
    platform: ' Android/iOS',
    engine: ' Unity',
    isVideo: 'true',
    isBig: false
  },
  {
    id: 3,
    title: "Game MechaMIX Vol. I",
    desc: "Singleplayer puzzle platformer that combines two game mechanics from different game franchises in one single level.",
    img: "../../assets/mechamixvolI.png",
    link: "https://nestorsaga.itch.io/game-mechamix-vol-i",
    tags: ['Solo Project'],
    role: ' Code/Design/UI/3DArt',
    platform: ' PC',
    engine: ' Unity',
    isBig: false
  },  
  {
    id: 4,
    title: "Dragon's Den",
    desc: "Singleplayer fantasy medieval investing simulator where you invest your way back to your world.",
    img: "../../assets/dd.png",
    link: "https://leo-knight98.itch.io/dragons-den",
    tags: ['Team Project', 'GameJam'],
    role: ' Code/Design',
    platform: ' PC',
    engine: ' Unity',
    isBig: false
  },
  {
    id: 5,
    title: "Will Will Will",
    desc: "2-player 2D fist fight for Will's will. Made for the 2022 Global Game Jam. Theme: Duality",
    img: "../../assets/WILL.png",
    link: "https://twodas.itch.io/will-will-will",
    tags: ['Team Project', 'GameJam'],
    role: ' Design/Code',
    platform: ' PC',
    engine: ' Unity',
    isBig: false
  },
  {
    id: 6,
    title: "El drac",
    desc: "2-player asymmetric battle between Sant Feliu's iconic characters. Made for the 2021 Power Up Sant Feliu de Llobregat Game Jam",
    img: "../../assets/sfeliu.png",
    link: "https://nestorsaga.itch.io/sant-feliu-contra-el-diable",
    tags: ['Team Project', 'GameJam'],
    role: ' 3DArt/Design/Code',
    platform: ' PC',
    engine: ' Unity',
    isBig: false
  },
  {
    id: 7,
    title: "CPlay",
    desc: "Puzzle platformer where you repair the scenario by 'reprogramming' it. Made for the 2020 Global Game Jam. Theme: Repair",
    img: "../../assets/cplay1.png",
    link: "https://globalgamejam.org/2020/games/cplay-5",
    tags: ['Team Project', 'GameJam'],
    role: ' Code',
    platform: ' PC',
    engine: ' Unity',
    isBig: false
  },
  {
    id: 8,
    title: "Project Gravit",
    desc: "First person action platformer set in a futuristic corporation facility. Repulse, atract and finish the enemies to seek your answers",
    img: "../../assets/PGRAVIT.png",
    link: "https://twodas.itch.io/project-gravit",
    tags: ['Team Project'],
    role: ' Code',
    platform: ' PC',
    engine: ' Unity',
    isBig: false
  },
  {
    id: 9,
    title: "Schrö",
    desc: "Frenetic 2-player 2D cube-fighting trap-setting and timeline-splitting game. Made for the 2019 Granollers Game Jam",
    img: "../../assets/schro1.png",
    link: "https://drive.google.com/file/d/1sJuEEmwIFmBLhQoYFQc0m2Z2bYQwmt1m/view",
    tags: ['Team Project', 'GameJam'],
    role: ' Design/Code',
    platform: ' PC',
    engine: ' Unity',
    isBig: false
  }
];